// Editorial photography for Explore Nepal — authentic local assets only.
// External stock URLs removed. Use nepalImages.js for verified photos.
import abcTrek from '../images/abc-trek.jpg';
import nepalVillage from '../images/nepal-village.jpg';
import peacePagoda from '../images/peace.jpg';
import janakiMandir from '../images/janaki-mandir.jpg';

export const EXPLORE_IMAGES = {
	hero: '/images/hero-nepal.jpg',
	himalaya: '/images/hero-nepal.jpg',
	annapurna: abcTrek,
	valley: peacePagoda,
	wildlife: nepalVillage,
	seasonal: '/images/hero-nepal.jpg',
	monastery: peacePagoda,
	trekking: '/images/hero-nepal.jpg',
	festival: nepalVillage,
	janakiMandir,
	luxury: nepalVillage,
	budget: abcTrek,
};
